import React from 'react';
import PropTypes from 'prop-types';
import Drawer from 'material-ui/Drawer';
import List, { ListItem, ListItemText } from 'material-ui/List';
import Divider from 'material-ui/Divider';

const MobileMenu = ({ isopen, handleClose, handleDownload }) => {
  return (
    <Drawer
      open={isopen}
      className="mobile-menu"
    >
      <List>
        <ListItem button>
          <ListItemText className="parent" onClick={() => handleClose('qatar-charity')} primary="Qatar Charity" />
        </ListItem>
        <Divider />
        <ListItem button>
          <ListItemText className="parent" primary="Qatar Charity in UK" />
        </ListItem>
        <Divider />
        <ListItem button>
          <ListItemText className="child" onClick={() => handleClose('qcuk+history')} primary="History" />
        </ListItem>
        <ListItem button>
          <ListItemText className="child" onClick={() => handleClose('qcuk+leadership')} primary="Leadership" />
        </ListItem>
        <ListItem button>
          <ListItemText className="child" onClick={() => handleClose('qcuk+funding')} primary="Funding" />
        </ListItem>
        <Divider />
        <ListItem button>
          <ListItemText className="parent" primary="Emaan Trust" />
        </ListItem>
        <Divider />
        <ListItem button>
          <ListItemText className="child" onClick={() => handleClose('sheffield+history')} primary="History" />
        </ListItem>
        <ListItem button>
          <ListItemText className="child" onClick={() => handleClose('sheffield+leadership')} primary="Leadership" />
        </ListItem>
        <ListItem button>
          <ListItemText className="child" onClick={() => handleClose('sheffield+funding')} primary="Funding" />
        </ListItem>
        <Divider />
        <ListItem button>
          <ListItemText className="parent" primary="Download" onClick={() => handleDownload()} />
        </ListItem>
      </List>
    </Drawer>
  );
};

MobileMenu.propTypes = {
  handleClose: PropTypes.func,
  handleDownload: PropTypes.func,
  isopen: PropTypes.bool,
};

export default MobileMenu;



// WEBPACK FOOTER //
// ./scripts/components/MobileMenu.jsx